if (document.body.classList.contains('single-people')) {
	if (window.location.hash) {
		const year = window.location.hash;
		const prevLink = document.querySelector('.previous-link a');
		prevLink.href = prevLink.href + year;
	}
}